// src/components/PreviewSection.jsx
import React, { useState } from "react";
import PreviewModal from "./PreviewModal";
import sampleBirthdayCard from "../assets/Generated_Examples/10.jpeg";

export function PreviewSection({ onCreateClick }) {
  /* ---------------------------------------------------------
     Local state for the sample preview card
     ------------------------------------------------------- */
  const [showPreview, setShowPreview] = useState(false);

  /* Front headline text */
  const [frontText, setFrontText] = useState({
    fontFamily: "'Lilita One', cursive",
    fontSize: 48,
    fill: "#ffffff",
    stroke: "",
    strokeWidth: 0,
    rotation: 0,
    animStyle: "none",
    x: 50,
    y: 200,
  });

  /* Inside message */
  const [insideText, setInsideText] = useState(
    `Dear Jenny,\n\nWishing you a day filled with laughter, love, and all of your favourite things. May your year ahead sparkle with joy and adventure.\n\nWith love,\nSarah`
  );

  const cardState = {
    imageUrl: sampleBirthdayCard,
    text: frontText,
    setText: setFrontText,
    inside: insideText,
    setInside: setInsideText,
    insideFont: "'Inter', sans-serif",
    signatures: [], // Signature is already part of insideText
  };

  const openPreview = () => setShowPreview(true);

  return (
    <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-12 bg-gray-50 font-poppins">
      <div className="max-w-7xl mx-auto text-center mb-8 sm:mb-12 md:mb-16">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-3 sm:mb-4">
          Experience Our Interactive E-Cards
        </h2>
        <p className="text-lg sm:text-xl text-gray-600 px-4 sm:px-0">
          Click to open this sample e-card and see the magic
        </p>
      </div>

      <div className="max-w-lg mx-auto">
        {/* faux email preview box */}
        <div className="bg-white rounded-xl shadow-lg p-6 mb-8">
          <div className="flex items-center mb-4">
            <div className="w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center text-indigo-600">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
            </div>
            <div className="ml-3 text-left">
              <h4 className="font-medium text-gray-800">DreamableAI</h4>
              <p className="text-sm text-gray-500">
                You've received a card from Sarah!
              </p>
            </div>
          </div>

          <div className="border-t border-b border-gray-200 py-4 my-4">
            <p className="text-gray-600 mb-4">Hi there,</p>
            <p className="text-gray-600 mb-4">
              Sarah has sent you a special birthday greeting card. Click below
              to view your card:
            </p>
          </div>

          {/* clickable card thumbnail */}
          <div
            id="cardPreview"
            onClick={openPreview}
            className="bg-indigo-50 rounded-lg p-4 mb-4 cursor-pointer hover:bg-indigo-100 transition"
          >
            <div className="aspect-w-16 aspect-h-9 mb-3">
              <div className="w-full h-32 bg-cover bg-center rounded"
                   style={{ backgroundImage: `url(${sampleBirthdayCard})` }}
              />
            </div>
            <div className="text-center">
              <p className="font-medium text-indigo-600">Happy Birthday!</p>
              <p className="text-sm text-indigo-500">Click to open your card</p>
            </div>
          </div>

          <button
            id="viewCardBtn"
            onClick={openPreview}
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-3 rounded-lg font-medium transition"
          >
            View Your Card
          </button>

          <div className="mt-4 text-center text-xs text-gray-500">
            Sent with ❤️ via DreamableAI
          </div>
        </div>

        <div className="text-center text-gray-600">
          <p>
            Click the preview or button above to open the interactive e-card
          </p>
        </div>

        {onCreateClick && (
          <div className="text-center mt-8">
            <button
              onClick={onCreateClick}
              className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg font-medium hover:from-indigo-700 hover:to-purple-700 transition shadow-lg"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
              </svg>
              Create Your Own Card
            </button>
          </div>
        )}
      </div>

      {/* PreviewModal is conditionally rendered */}
      {showPreview && (
        <PreviewModal cardState={cardState} onClose={() => setShowPreview(false)} />
      )}
    </section>
  );
}
  